module.exports = __webpack_public_path__ + "assets/images/img_accuracy_validation_illustration_1.png";